import axios from 'axios';
import toSnakeCase from 'to-snake-case';
import _ from 'lodash';

import * as Constants from './constants';


export const xapi = (fileUpload = false) => {
  let headers = {
    'X-Requested-With': 'XMLHttpRequest'
  };

  if (fileUpload) {
    headers = {
      ...headers,
      'Content-Type': 'multipart/form-data'
    }
  }

  return axios.create({
    baseURL: Constants.BASE_URL,
    headers: {
      ...headers,
      Accept: 'application/json'
    }
  });
};

export const snakeCaseKeys = obj => {
  let snake_case_obj;

  if (obj instanceof Array) {
    return obj.map(element => {
      let newObj = element;
      if (typeof element === 'object') {
        newObj = snakeCaseKeys(element);
      }
      return newObj;
    });
  } else {
    snake_case_obj = {};

    for (const objKey in obj) {
      if (obj.hasOwnProperty(objKey)) {
        const newObjKey = toSnakeCase(objKey);
        let keyValue = obj[objKey];

        if (
          keyValue instanceof Array ||
          (keyValue !== null && keyValue !== undefined && keyValue.constructor === Object)
        ) {
          keyValue = snakeCaseKeys(keyValue);
        }
        snake_case_obj[newObjKey] = keyValue;
      }
    }
  }

  return snake_case_obj;
};

export const convertObjectKeyToCamelCase = obj => {
  let camelCaseObj;

  if (obj instanceof Array) {
    return obj.map(element => {
      let newObj = element;
      if (typeof element === 'object') {
        newObj = convertObjectKeyToCamelCase(element);
      }
      return newObj;
    });
  } else {
    camelCaseObj = {};

    for (const objKey in obj) {
      if (obj.hasOwnProperty(objKey)) {
        const newObjKey = _.camelCase(objKey);
        let keyValue = obj[objKey];

        if (
          keyValue instanceof Array ||
          (keyValue !== null && keyValue !== undefined && keyValue.constructor === Object)
        ) {
          keyValue = convertObjectKeyToCamelCase(keyValue);
        }
        camelCaseObj[newObjKey] = keyValue;
      }
    }
  }

  return camelCaseObj;
};
